import { render } from "./result.vue?vue&type=template&id=18ac6725"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=18ac6725&lang=sass"
script.render = render

export default script